import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "px-9 pt-7 card-rounded h-275px w-100 bg-success-with-gradient" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "m-0 text-white text-center fw-bolder fs-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ms-1" }, null, -1)
const _hoisted_8 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_9 = { class: "fw-bold fs-7" }
const _hoisted_10 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_11 = {
  class: "bg-body shadow-lg card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1",
  style: {"margin-top":"-100px"}
}
const _hoisted_12 = { class: "d-flex align-items-center mb-6" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-45px w-40px me-5\"><span class=\"symbol-label bg-lighten\"><span class=\"svg-icon svg-icon-1\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path opacity=\"0.3\" d=\"M18.4 5.59998C21.9 9.09998 21.9 14.8 18.4 18.3C14.9 21.8 9.2 21.8 5.7 18.3L18.4 5.59998Z\" fill=\"currentColor\"></path><path d=\"M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM19.9 11H13V8.8999C14.9 8.6999 16.7 8.00005 18.1 6.80005C19.1 8.00005 19.7 9.4 19.9 11ZM11 19.8999C9.7 19.6999 8.39999 19.2 7.39999 18.5C8.49999 17.7 9.7 17.2001 11 17.1001V19.8999ZM5.89999 6.90002C7.39999 8.10002 9.2 8.8 11 9V11.1001H4.10001C4.30001 9.4001 4.89999 8.00002 5.89999 6.90002ZM7.39999 5.5C8.49999 4.7 9.7 4.19998 11 4.09998V7C9.7 6.8 8.39999 6.3 7.39999 5.5ZM13 17.1001C14.3 17.3001 15.6 17.8 16.6 18.5C15.5 19.3 14.3 19.7999 13 19.8999V17.1001ZM13 4.09998C14.3 4.29998 15.6 4.8 16.6 5.5C15.5 6.3 14.3 6.80002 13 6.90002V4.09998ZM4.10001 13H11V15.1001C9.1 15.3001 7.29999 16 5.89999 17.2C4.89999 16 4.30001 14.6 4.10001 13ZM18.1 17.1001C16.6 15.9001 14.8 15.2 13 15V12.8999H19.9C19.7 14.5999 19.1 16.0001 18.1 17.1001Z\" fill=\"currentColor\"></path></svg></span></span></div>", 1)
const _hoisted_14 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_15 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
}, "Hacking Club VPN Server", -1)
const _hoisted_17 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "bi bi-check-circle-fill text-success",
    style: {"margin-right":"0.5rem"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-5 text-gray-800 pe-1 me-1" }, "Operacional")
], -1)
const _hoisted_19 = { class: "d-flex align-items-center mb-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px w-40px me-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-lighten" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "bi bi-person-circle",
      style: {"font-size":"2rem"}
    })
  ])
], -1)
const _hoisted_21 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_22 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_23 = {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
}
const _hoisted_24 = { class: "text-gray-500" }
const _hoisted_25 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_26 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "bi bi-check-circle-fill text-success",
  style: {"margin-right":"0.5rem"}
}, null, -1)
const _hoisted_28 = { class: "fw-bolder fs-5 text-gray-800 pe-1 me-1" }
const _hoisted_29 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-exclamation-square-fill text-danger",
  style: {"margin-right":"0.5rem"}
}, null, -1)
const _hoisted_31 = { class: "fw-bolder fs-5 text-gray-800 pe-1 me-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-6" }, null, -1)
const _hoisted_33 = { class: "d-flex align-items-center justify-content-center justify-center" }
const _hoisted_34 = ["title", "disabled"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_36 = { class: "m1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.vpn.access_to_the_hacking_club_network`)), 1),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.vpn.your_private_ip_address`)), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.currentVPN.vpn_virtual_ip || "0.0.0.0"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.vpn.our_vpn_server_is_located_in_the_cloud`)) + " (aws) ", 1)
              ]),
              _hoisted_18
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("a", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.you`)) + " ", 1),
                  _createElementVNode("small", _hoisted_24, " - " + _toDisplayString(_ctx.user.nick), 1)
                ]),
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.vpn.status_of_your_connection`)), 1)
              ]),
              (_ctx.currentVPN.vpn_online)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.vpn.connected_from_the_VPN`)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.vpn.disconnected_from_the_VPN`)), 1)
                  ]))
            ])
          ]),
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              title: _ctx.currentVPN.vpn_virtual_ip ? 'Configuration file used to access Hacking Club VPN': 'We are still generating your VPN file' ,
              type: "button",
              class: "btn btn-secondary btn-lg btn-block",
              disabled: !_ctx.currentVPN.vpn_virtual_ip,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadVPN()))
            }, [
              _hoisted_35,
              _createElementVNode("b", _hoisted_36, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.vpn.download_the_VPN_configuration_file`)), 1)
            ], 8, _hoisted_34)
          ])
        ])
      ])
    ])
  ]))
}